import {useNavigate, To} from 'react-router-dom'

export const useViewNavigate = () => {
  const navigate = useNavigate()

  const fadeNavigate = (newRoute: To | number) => {
    const root = document.getElementById('root')

    if (!root || !document.startViewTransition) {
      if (root) {
        root.style.transition = 'opacity 0.25s ease-in-out'
        root.style.opacity = '0'
      }

      setTimeout(() => {
        // Type guard: call the correct overload
        if (typeof newRoute === 'number') {
          navigate(newRoute) // history delta
        } else {
          navigate(newRoute) // path string
        }

        if (root) {
          root.style.opacity = '1'
        }
      }, 250)

      return
    }

    // View Transitions API
    document
      .startViewTransition(() => {
        if (typeof newRoute === 'number') {
          navigate(newRoute)
        } else {
          navigate(newRoute)
        }
      })
      .ready.then(() => {
        if (root) {
          root.animate([{opacity: 0.5}, {opacity: 1}], {duration: 500, easing: 'ease-in-out'})
        }
      })
  }

  return fadeNavigate
}
